// extracted by mini-css-extract-plugin
export default {"modalCard":"UserMfaModal_modalCard__fsHcV","form":"UserMfaModal_form__Ca+Jd","buttonWrapper":"UserMfaModal_buttonWrapper__xsMPi","description":"UserMfaModal_description__H2wKd"};